import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import { mediaMax, spacing } from 'presentations/views/styles';
import styled from '@emotion/styled';
import SectionTitle from 'presentations/views/components/molecules/ServiceSectionTitle';
import ContentItem1 from 'presentations/views/components/molecules/ServiceContentItem1';
import HowToUse from 'presentations/views/components/organisms/service/PaymentHowToUse';
import Commission from 'presentations/views/components/organisms/service/PaymentCommission';

export default function Component() {
  const t = translateInComponent(translations);
  return (
    <>
      <SectionTitle
        title={t('title')}
        titleEn={t('title en')}
        description={t('description')}
      />
      <HowToSectionContainer>
        <HowToUse />
      </HowToSectionContainer>
      <PaymentContainer>
        <Commission />
      </PaymentContainer>
      <ListContainer>
        <ListItem>
          <ContentItem1
            imageUrl="pages/features/stripe.png"
            imageWidth={537}
            imageHeight={440}
            title={t('item 1 title')}
            description={t('item 1 description')}
          />
        </ListItem>
      </ListContainer>
    </>
  );
}

const ListContainer = styled.div``;

const ListItem = styled.div`
  margin-bottom: ${spacing(96)};
  :last-of-type {
    margin-bottom: 0;
  }
  ${mediaMax.tablet} {
    margin-bottom: ${spacing(48)};
  }
`;

const HowToSectionContainer = styled.div`
  max-width: 1180px;
  margin-bottom: ${spacing(64)};
`;
const PaymentContainer = styled.div`
  max-width: 1180px;
  margin-bottom: ${spacing(96)};
`;
